let view = null;

export default {
	namespace: 'template-collaboration',
	beforeEnter: async ({ current, next, trigger }) => {
		const { default: CollaborationView } = await import(
			/* webpackChunkName: "collaboration-view" */ '../../templates/CollaborationView'
		);
		view = new CollaborationView(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
